import { defaultTheme } from 'gd-design-library';

export const list = {
  ...defaultTheme.list,
  item: {
    ...defaultTheme.list.item,
    default: {
      ...defaultTheme.list.item.default,
      alignItems: 'flex-start',
      gap: '0.5rem',
      lineHeight: 'normal'
    },
    'unordered-dot': {
      ...defaultTheme.list.item['unordered-dot'],
      '& .List__bulletPoint': {
        lineHeight: '1'
      }
    }
  }
};
